export interface HotjarIdByUrlProps {
    [x: string]: {
        hjid: number; // hotjar id
        hjsv: number; // hotjar snippet version
    };
}

const HOTJAR_ID_BY_URL: HotjarIdByUrlProps = {
    // Matches all subdomains of ee.inscyth.com
    'https:\\/\\/[^.]+\\.ee\\.inscyth\\.com': {
        hjid: 3185273,
        hjsv: 6,
    },
};

export default HOTJAR_ID_BY_URL;
